import { EventEmitter } from '@angular/core';
import { IconSearchAutocompleteComponent } from 'SearchApp/ts/features/icon-search-autocomplete/icon-search-autocomplete.component';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i2 from "../../../../../../search/static/search/ts/features/icon-search-autocomplete/icon-search-autocomplete.component";
import * as i3 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i4 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i5 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i6 from "../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
function CustomBenchmarkSelectorModalComponent_Conditional_11_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "span", 10);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 11)(4, "button", 12);
    i0.ɵɵlistener("click", function CustomBenchmarkSelectorModalComponent_Conditional_11_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.clearSelection()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(5, "svg", 13);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.displayName);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-close");
} }
function CustomBenchmarkSelectorModalComponent_Conditional_12_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-icon-search-autocomplete", 14);
    i0.ɵɵlistener("submitHandler", function CustomBenchmarkSelectorModalComponent_Conditional_12_Template_ycn_icon_search_autocomplete_submitHandler_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onSelect($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("placeholder", "Benchmark")("searchType", "securities_with_calcs");
} }
export class CustomBenchmarkSelectorModalComponent {
    constructor() {
        this.submitHandler = new EventEmitter();
        this.cancelHandler = new EventEmitter();
        this.isOpen = false;
        this.displayName = null;
        this.pendingResult = null;
    }
    openModal(currentBenchmarkName = '') {
        this.displayName = currentBenchmarkName || null;
        this.pendingResult = null;
        this.isOpen = true;
        if (!this.displayName) {
            setTimeout(() => this.autocompleter?.reset());
        }
    }
    closeModal() {
        this.isOpen = false;
        this.cancelHandler.emit();
    }
    clearSelection() {
        this.displayName = null;
        this.pendingResult = null;
        setTimeout(() => this.autocompleter?.reset());
    }
    onSelect(result) {
        this.pendingResult = result;
        this.displayName = result.name;
        // BaseAutocompleteComponent dispatches resetAutocompleter synchronously before emitting,
        // which clears the native input. Set it back after that cycle completes.
        setTimeout(() => {
            const inputEl = this.autocompleter?.baseAutocompleter?.searchBarComponent?.textInput?.nativeElement;
            if (inputEl)
                inputEl.value = result.name;
        });
    }
    save() {
        if (!this.pendingResult)
            return;
        this.isOpen = false;
        this.submitHandler.emit(this.pendingResult);
    }
    onEscapeKey() {
        if (this.isOpen)
            this.closeModal();
    }
    onEnterKey() {
        // Only save on Enter when the name is displayed — not while the autocomplete
        // dropdown is active, where Enter is used to confirm a result selection.
        if (this.isOpen && this.displayName)
            this.save();
    }
}
CustomBenchmarkSelectorModalComponent.ɵfac = function CustomBenchmarkSelectorModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CustomBenchmarkSelectorModalComponent)(); };
CustomBenchmarkSelectorModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CustomBenchmarkSelectorModalComponent, selectors: [["ycn-custom-benchmark-selector-modal"]], viewQuery: function CustomBenchmarkSelectorModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(IconSearchAutocompleteComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.autocompleter = _t.first);
    } }, hostBindings: function CustomBenchmarkSelectorModalComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("keydown.escape", function CustomBenchmarkSelectorModalComponent_keydown_escape_HostBindingHandler() { return ctx.onEscapeKey(); }, i0.ɵɵresolveDocument)("keydown.enter", function CustomBenchmarkSelectorModalComponent_keydown_enter_HostBindingHandler() { return ctx.onEnterKey(); }, i0.ɵɵresolveDocument);
    } }, outputs: { submitHandler: "submitHandler", cancelHandler: "cancelHandler" }, standalone: false, decls: 14, vars: 6, consts: [[3, "closeModalHandler", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section"], [1, "form-row"], [1, "form-label"], ["ycnTooltip", "", 3, "tooltipTitle"], [1, "input-group", "field-input-group"], [3, "placeholder", "searchType"], [3, "cancelHandler", "submitHandler", "submitButtonText", "disableSubmission"], [1, "form-control"], [1, "input-group-append"], ["type", "button", 1, "btn", "btn-secondary", 3, "click"], ["ycnIcon", "", 3, "name"], [3, "submitHandler", "placeholder", "searchType"]], template: function CustomBenchmarkSelectorModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function CustomBenchmarkSelectorModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function CustomBenchmarkSelectorModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "p");
        i0.ɵɵtext(5, "Select a custom benchmark to use for this fund.");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 4)(7, "div", 5);
        i0.ɵɵtext(8, " CUSTOM BENCHMARK ");
        i0.ɵɵelementStart(9, "span", 6);
        i0.ɵɵtext(10, "(?)");
        i0.ɵɵelementEnd()();
        i0.ɵɵconditionalCreate(11, CustomBenchmarkSelectorModalComponent_Conditional_11_Template, 6, 2, "div", 7)(12, CustomBenchmarkSelectorModalComponent_Conditional_12_Template, 1, 2, "ycn-icon-search-autocomplete", 8);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(13, "ycn-simple-modal-footer", 9);
        i0.ɵɵlistener("cancelHandler", function CustomBenchmarkSelectorModalComponent_Template_ycn_simple_modal_footer_cancelHandler_13_listener() { return ctx.closeModal(); })("submitHandler", function CustomBenchmarkSelectorModalComponent_Template_ycn_simple_modal_footer_submitHandler_13_listener() { return ctx.save(); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.isOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Select Custom Benchmark");
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("tooltipTitle", "Search for a security to use as a custom benchmark for this fund.");
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.displayName ? 11 : 12);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("submitButtonText", "Save")("disableSubmission", !ctx.pendingResult);
    } }, dependencies: [i1.IconDirective, i2.IconSearchAutocompleteComponent, i3.ModalBaseComponent, i4.SimpleModalFooterComponent, i5.SimpleModalHeaderComponent, i6.TooltipDirective], encapsulation: 2 });
